import {useEffect, useState} from 'react';
import subDays from 'date-fns/subDays';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import addDays from "date-fns/addDays";
import endOfDay from "date-fns/endOfDay";

export const useTypeDataAnalytic = (date, setFilter, {min, max}, customerId, customRange = {}) => {
  const [aMonthAgo, setAMonthAgo] = useState();
  const [lastMonthDays, setLastMonthDays] = useState([]);

  const dateAllCustomer = (min = new Date(), max = new Date()) => {
    const days = differenceInCalendarDays(new Date(max), new Date(min)) + 1;
    setAMonthAgo(subDays(new Date(max), days));
    setLastMonthDays(Array.from({length: days}, (_, i) => subDays(new Date(max), i)));
  }

  // Pre-defined dates processing
  useEffect(() => {
    if (date !== 'all' && date !== 'custom' && date) {
      setAMonthAgo(addDays(new Date(), date));
      if (date > 0) {
        setLastMonthDays(Array.from({length: date}, (_, i) => addDays(new Date(), i)));
        setFilter(e => ({...e, start: new Date(), end: endOfDay(addDays(new Date(), date)), all: false}));
      } else {
        setLastMonthDays(Array.from({length: date * -1}, (_, i) => addDays(new Date(), -i)));
        setFilter(e => ({...e, start: addDays(new Date(), date), end: endOfDay(new Date()), all: false}));
      }
    }
  }, [setFilter, date]);

  // `All` processing
  useEffect(() => {
    if (date === 'all' && min && max) {
      dateAllCustomer(min, max);
    }
    if (date === 'all') {
      setFilter(e => ({...e, all: true}));
    }
  }, [setFilter, date, min, max, customerId]);

  // Custom range processing
  useEffect(() => {
    if (date === 'custom' && customRange.start && customRange.end) {
      const start = new Date(customRange.start);
      const end = endOfDay(new Date(customRange.end));
      const days = differenceInCalendarDays(end, start) + 1;
      
      setAMonthAgo(subDays(end, days));
      setLastMonthDays(Array.from({length: days}, (_, i) => addDays(start, i)));
      setFilter(e => ({...e, start, end, all: false}));
    }
  }, [setFilter, date, customRange.start, customRange.end]);

  return [aMonthAgo, lastMonthDays];
};